module.exports = __webpack_public_path__ + "fonts/LineIconsPro Light.6041ed8.eot";